import { useSelector } from '@hozana/redux/hooks'

import { selectCommunity } from '../selectors'
import type { TCommunity } from '../types'

export const useCommunity = ({ communityId }: { communityId: number }): TCommunity | undefined =>
  useSelector((state) => selectCommunity(state, communityId))
